<template>
  <div class="privacy-policy">
    <h1 class="page-title">POLITIQUE DE CONFIDENTIALITÉ</h1>
    <h3 class="paragraph-title">1. Préambule</h3>
    <p>Cette application respecte et protège la vie privée de tous les utilisateurs qui utilisent le service. Afin de
      vous fournir des services plus précis et personnalisés, cette application utilisera et divulguera vos informations
      personnelles conformément aux dispositions de la présente politique de confidentialité. Toutefois, cette
      application traitera ces informations avec un haut degré de diligence et de prudence. Sauf disposition contraire
      de la présente politique de confidentialité, l'application ne divulguera ni ne fournira ces informations à des
      tiers sans votre autorisation préalable. Cette application mettra à jour cette politique de confidentialité de
      temps à autre. Lorsque vous acceptez cet accord d'utilisation des services de l'application, vous êtes réputé
      avoir accepté le contenu intégral de cette politique de confidentialité. La présente politique de confidentialité
      fait partie intégrante de l'accord d'utilisation du service d'application.</p>

    <h3 class="paragraph-title">2. Portée de l'application</h3>
    <p>(a) lorsque vous enregistrez ce compte d'application, vous fournissez des informations d'enregistrement
      personnelles conformément aux exigences de l'application ;</p>
    <p>(b) lorsque vous utilisez le service de réseau de l'application ou que vous visitez les pages web de la
      plate-forme d'application, l'application reçoit et enregistre automatiquement des informations sur votre
      navigateur et votre ordinateur, y compris, mais sans s'y limiter, votre adresse IP, le type de navigateur, la
      langue utilisée, la date et l'heure d'accès, les caractéristiques du logiciel et du matériel, et les
      enregistrements des pages web de vos besoins. Telles que les données ; les données personnelles de l'utilisateur
      obtenues de partenaires commerciaux par des moyens légitimes.</p>
    <p>Vous comprenez et acceptez que les informations suivantes ne sont pas applicables à la présente politique de
      confidentialité :</p>
    <p>(a) les informations relatives aux mots-clés que vous saisissez lorsque vous utilisez le service de recherche
      fourni par cette plateforme d'application ;</p>
    <p>(b) les informations et données pertinentes collectées par cette application, y compris, mais sans s'y limiter,
      les activités participatives, les informations sur les transactions et les détails des évaluations, sont publiées
      par vous dans cette application ;</p>
    <p>Les violations des lois ou les violations des règles d'application et les mesures qui ont été prises à votre
      égard dans cette application.</p>

    <h3 class="paragraph-title">3. Utilisation des informations</h3>
    <p>(a) L'application ne fournira pas, ne vendra pas, ne louera pas, ne partagera pas ou n'échangera pas vos
      informations personnelles à un tiers non lié, sauf si une autorisation préalable est obtenue de votre part, ou si
      le tiers et l'application (y compris ses affiliés) fournissent seuls ou conjointement des services pour vous, et
      après la fin du service, l'accès sera interdit, y compris pour ses capacités précédentes. Un accès suffisant à
      toutes ces informations.</p>
    <p>(b) Cette application ne permet pas non plus à un tiers de collecter, modifier, vendre ou diffuser gratuitement
      vos informations personnelles par quelque moyen que ce soit. Si un utilisateur de la plate-forme de cette
      application se livre aux activités susmentionnées, l'application a le droit de mettre fin à l'accord de service
      avec cet utilisateur dès qu'elle le découvre.</p>
    <p>Dans le but de servir les utilisateurs, l'application peut utiliser vos informations personnelles pour vous
      fournir des informations d'intérêt, y compris, mais sans s'y limiter, des produits et services, ou pour partager
      des informations avec les partenaires de l'application afin qu'ils puissent vous envoyer des informations sur
      leurs produits et services (ce dernier point nécessite votre accord préalable).</p>

    <h3 class="paragraph-title">4. Divulgation d'informations</h3>
    <p>Dans les cas suivants, cette application divulguera vos informations personnelles en totalité ou en partie selon
      vos souhaits personnels ou les dispositions légales :</p>
    <p>(a) pour être divulguées à un tiers avec votre accord préalable.</p>
    <p>(b) vous devez partager vos informations personnelles avec le tiers afin de fournir les produits et services que
      vous demandez.</p>
    <p>(c) Divulgation à des tiers ou à des organes administratifs ou judiciaires conformément aux dispositions
      pertinentes de la loi ou aux exigences des organes administratifs ou judiciaires ;</p>
    <p>(d) Si vous violez les lois et règlements pertinents de la Chine ou le présent contrat de service d'application
      ou les règles pertinentes, vous devez les divulguer à un tiers ;</p>
    <p>(e) Si vous êtes un plaignant qualifié en matière de propriété intellectuelle et que vous avez déposé une
      plainte, vous devez la divulguer au défendeur à la demande de ce dernier afin que les deux parties puissent gérer
      les éventuels litiges relatifs aux droits ;</p>
    <p>(f) Dans une transaction créée sur cette plateforme d'application, si l'une des parties a rempli ou partiellement
      rempli ses obligations commerciales et a fait une demande de divulgation d'informations, l'application a le droit
      de décider de fournir à l'utilisateur les informations nécessaires telles que le mode de contact de l'autre partie
      de la transaction, de manière à faciliter la réalisation de la transaction ou le règlement des litiges.</p>
    <p>(g) d'autres applications qui sont considérées comme appropriées selon les lois, les règlements ou les politiques
      du site web.</p>

    <h3 class="paragraph-title">5. Stockage et échange d'informations</h3>
    <p>Les informations et données collectées par cette application seront stockées sur le serveur de cette application
      et/ou de sa société affiliée. Ces informations et données peuvent être transmises dans votre pays, votre région ou
      à l'étranger où les informations et données collectées par cette application sont situées et consultées, stockées
      et affichées à l'étranger.</p>

    <h3 class="paragraph-title">6. L'utilisation de cookies </h3>
    <p>(a) Si vous ne refusez pas d'accepter les cookies, l'application définira ou accédera à des cookies sur votre
      ordinateur afin que vous puissiez vous connecter ou utiliser les services ou fonctions de la plate-forme
      d'application dépendant des cookies. L'application de cookies peut vous fournir des services personnalisés plus
      réfléchis, y compris des services de promotion.</p>
    <p>(b) vous avez le droit de choisir d'accepter ou de refuser les cookies. Vous pouvez refuser d'accepter les
      cookies en modifiant les paramètres du navigateur. Mais si vous choisissez de rejeter les cookies, il se peut que
      vous ne puissiez pas vous connecter ou utiliser les services ou fonctions du réseau d'applications natives
      dépendant des cookies.</p>
    <p>Cette politique s'appliquera aux informations obtenues par les cookies dans cette application.</p>

    <h3 class="paragraph-title">7. sécurité des informations</h3>
    <p>(a) le compte de cette application a une fonction de protection de sécurité. Veuillez conserver correctement vos
      informations de nom d'utilisateur et de mot de passe. Cette application veillera à ce que vos informations ne
      soient pas perdues, utilisées de manière abusive ou modifiées en cryptant les mots de passe des utilisateurs et
      autres mesures de sécurité. Malgré les mesures de sécurité susmentionnées, veuillez également noter qu'il n'existe
      pas de "mesures de sécurité parfaites" sur le réseau d'information.</p>
    <p>(b) Lorsque vous utilisez ce service de réseau d'applications pour des transactions en ligne, vous devrez
      inévitablement traiter avec la contrepartie ou les paires de transactions potentielles.</p>

    <h3 class="paragraph-title">8. Modifications de la politique de confidentialité</h3>
    <p>(a) Si nous décidons de modifier notre politique de confidentialité, nous publierons ces modifications dans cette
      politique, sur notre site Internet et là où nous le jugerons approprié, afin que vous puissiez comprendre comment
      nous collectons et utilisons vos informations personnelles, qui peut y accéder et dans quelles circonstances nous
      les divulguons.</p>
    <p>(b) notre société se réserve le droit de modifier cette politique à tout moment, veuillez donc la consulter
      régulièrement. Si un changement majeur est apporté à la politique, la société l'informera sous la forme d'un avis
      sur le site Web.</p>
    <p>Veuillez protéger correctement vos informations personnelles et ne les communiquer à des tiers qu'en cas de
      nécessité. Si vous constatez que vos informations personnelles sont divulguées, en particulier le nom
      d'utilisateur et le mot de passe de l'application, veuillez contacter immédiatement le service client de
      l'application afin que celui-ci puisse prendre les mesures appropriées.</p>
    <p>Si vous avez des questions sur cette politique ou d'autres sujets connexes, veuillez nous contacter. Vous pouvez
      également envoyer vos questions à info@bob.eco</p>
  </div>
</template>

<script>
export default {
  name: 'privacyPolicyFrOKADA'
}
</script>

<style scoped lang="less">
.privacy-policy {
  p {
    text-indent: 2em;
    margin: 10px;
  }

  .page-title {
    text-align: center;
  }

  .paragraph-title {
    text-indent: 0;
  }

  .bottom {
    margin: 40px 20px;
    text-align: center;
  }
}
</style>
